import React, { FC } from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';

interface ActivityItemProps {
    title: string;
    date?: string;
    time?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
    className?: string;
}

export const ActivityItem: FC<ActivityItemProps> = ({
    title,
    date,
    time,
    onClick,
    style,
    className = '',
}) => {
    const itemClasses = `flex flex-col rounded-xl border border-backgroundGreyAlt1 bg-white px-4 py-3 ${onClick ? 'cursor-pointer hover:bg-black/[0.02]' : 'cursor-default'
        }`;

    return (
        <div onClick={onClick} className={`${itemClasses} ${className}`} style={style} role={onClick ? 'button' : undefined}>
            <div className="flex w-full items-center justify-between">
                <p className="m-0 shrink-0 text-base font-medium text-blackTitle">{title}</p>
                {(date || time) && (
                    <div className="flex shrink-0 items-center gap-2">
                        <ClockCircleOutlined className="text-sm opacity-50" />
                        {date && <span className="text-sm font-normal leading-normal text-[#71717b]">{date}</span>}
                        {date && time && <span className="h-2 w-2 rounded-full bg-[#71717b]" />}
                        {time && <span className="text-sm font-normal leading-normal text-[#71717b]">{time}</span>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActivityItem;
